import React from "react";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import {
  STORAGE_LOCATIONS_URL,
  DELETE_STORAGE_LOCATION,
  SAVE_STORAGE_LOCATION,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function StorageLocationsListing() {
  const attributes = [{ key: "locationName", label: "Location Name", flex: 2 }];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);

  return (
    <GenericItemsListing
      items_URL={STORAGE_LOCATIONS_URL}
      SAVE_Item={SAVE_STORAGE_LOCATION}
      DELETE_Item={DELETE_STORAGE_LOCATION}
      title="Storage Locations"
      name="Location"
      icon={<PinDropRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
        uniqueId={"locationId"}
    />
  );
}

export default StorageLocationsListing;
